/**
 * @generated SignedSource<<f8b179c2977d93fbafb878e7f25f1fa7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ViewPageLabelsContentFragment_content$data = {
  readonly id: string | null;
  readonly labels: {
    readonly count: number | null;
    readonly nodes: ReadonlyArray<{
      readonly __typename: "Label";
      readonly id: string | null;
      readonly label: string | null;
      readonly name: string | null;
      readonly prefix: string | null;
    } | null> | null;
  } | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly space: {
    readonly id: string | null;
  } | null;
  readonly status: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "ViewPageLabelsContentFragment_content";
};
export type ViewPageLabelsContentFragment_content$key = {
  readonly " $data"?: ViewPageLabelsContentFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ViewPageLabelsContentFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASCENDING",
            "sortField": "LABELLING_CREATIONDATE"
          }
        }
      ],
      "concreteType": "PaginatedLabelList",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "label"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "prefix"
            }
          ]
        }
      ],
      "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "33f933ea2d7ab4c095f0bb74db186a37";

export default node;
